export const handleToastType = (error = '', errorMessage = '') => error && errorMessage === null ? 'warning' : 'error'
